const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  permission_routes: state => state.permission.routes
}

export default getters